import React, { useEffect, useContext } from 'react';
import { string, shape, bool } from 'prop-types';
import { Col } from '@thd-olt-component-react/grid';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { FullCard } from './FullCard';
import { GuideZoneCard } from './GuideZoneCard';
import { RentalZoneCard } from './RentalZoneCard';
import { InstallZoneCard } from './InstallZoneCard';
import { getCardType } from './Helpers';
import Model from './model/Model';
import { dataModel } from './dataModel';
import './category-cards-desktop.scss';
import { useCategoryCard } from "../hooks/useCategoryCard";

const CategoryCardsDesktop = ({
  keyword,
  navParam,
  storeId,
  data: propData,
  loading: propLoading,
  error: propError,
  ssr
}) => {
  const { store, clientStore } = useContext(ExperienceContext);
  const { data, loading, error } = useCategoryCard({
    clientStore,
    store,
    storeId,
    keyword,
    navParam,
    propLoading,
    propData,
    propError,
    ssr
  });

  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('category-cards.ready'); }, []);

  if (!keyword && !navParam && typeof propLoading === 'undefined') {
    return null;
  }

  /* eslint-disable-next-line react/prop-types */
  const renderCardByType = ({ header, details, type, major }) => {
    switch (type) {
    case 'guide': return <GuideZoneCard major={major} header={header} details={details} />;
    case 'rental': return <RentalZoneCard major={major} header={header} details={details} />;
    case 'install': return <InstallZoneCard major={major} header={header} details={details} />;
    default: return null;
    }
  };

  const renderFull = (categoryCards) => {
    const { majorDetails, majorHeader } = categoryCards;

    if (!majorHeader || !majorDetails) return null;

    const cardType = getCardType(majorHeader.title);

    return (
      <div className="category-cards">
        <Col className="category-cards__zone-wrapper category-cards__full-card">
          <FullCard type={cardType} header={majorHeader} details={majorDetails} />
        </Col>
      </div>
    );
  };

  const renderMultipleCards = (categoryCards) => {
    const { majorDetails, minorDetails, majorHeader, minorHeader } = categoryCards;

    return (
      <>
        {renderCardByType({
          header: majorHeader,
          details: majorDetails,
          type: getCardType(majorHeader.title),
          major: true
        })}
        {renderCardByType({
          header: minorHeader,
          details: minorDetails,
          type: getCardType(minorHeader.title),
          major: false
        })}
      </>
    );
  };

  const renderZone = (categoryCards) => {
    const { majorDetails, minorDetails, majorHeader, minorHeader } = categoryCards;

    if (!majorHeader || !majorDetails || !minorHeader || !minorDetails) return null;

    return (
      <Col className="category-cards">
        <div className="category-cards__zone-wrapper category-cards__zone-card">
          {renderMultipleCards(categoryCards)}
        </div>
      </Col>
    );
  };

  if (loading && !data) {
    return <div>Loading...</div>;
  }

  if (!data || !data?.searchModel?.orangeGraph || (!data && error)) {
    return null;
  }

  const categoryCards = new Model(data.searchModel.orangeGraph);

  return categoryCards.isFullCard('desktop')
    ? renderFull(categoryCards)
    : renderZone(categoryCards);
};

CategoryCardsDesktop.displayName = 'CategoryCardsDesktop';

CategoryCardsDesktop.dataModel = dataModel;

CategoryCardsDesktop.propTypes = {
  keyword: string,
  navParam: string,
  data: shape({}),
  loading: bool,
  error: shape({}),
  ssr: bool
};

CategoryCardsDesktop.defaultProps = {
  keyword: null,
  navParam: null,
  data: undefined,
  loading: undefined,
  error: undefined,
  ssr: false
};

export { CategoryCardsDesktop };
